export function isPositiveNumber(value: string | number): boolean {
  return String(value).trim() !== "" && Number.isFinite(Number(value)) && Number(value) > 0;
}
export function isPercentage(value: string | number): boolean {
  return String(value).trim() !== "" && Number.isFinite(Number(value)) && Number(value) >= 0 && Number(value) <= 100;
}
